import { IGanttEvent, IGanttSeries } from "@directives/_visualisations/ganttChart/ganttChart.component";
import { TranslationService } from "@services/translation.service";
import * as moment from "moment";
import { ReasonCode } from "../enum/ReasonCode";
import { IVideoEntry } from "../main/components/videos/models/IVideoEntry";
import { ColourService } from "./colour.service";
import { IHistoricalDay } from "./journey.service";
import { ReasonCodeService } from "./reasonCode.service";
import { VehicleInputService } from "./vehicleInput.service";

export class GanttSeriesService {
    static $inject = ["$timeout", "colourService", "reasonCodeService", "vehicleInputService", "translationService"];

    constructor(
        private readonly $timeout: angular.ITimeoutService,
        private readonly colourService: ColourService,
        private readonly reasonCodeService: ReasonCodeService,
        private readonly vehicleInputService: VehicleInputService,
        private readonly translationService: TranslationService
    ) {
    }  

    createJourneySeries(historicalDay: IHistoricalDay, min: moment.Moment = null, max: moment.Moment = null): IGanttSeries {
        if (!historicalDay.journeyModel) {
            return null;
        }

        var journeyEvents: IGanttEvent[] = [];
        historicalDay.journeyModel.journeys.forEach(journey => {
            var startUtc = moment(journey.StartUtc);
            var endUtc = moment(journey.EndUtc);

            if (min && max && this.isInRange(min, max, startUtc, endUtc)) {
                return;
            }

            if (min && min.isAfter(startUtc)) {
                startUtc = min;
            }


            if (max && max.isBefore(endUtc)) {
                endUtc = max;
            }

            journeyEvents.push({
                startUtc: startUtc,
                endUtc: endUtc,
                className: this.colourService.getJourneyBackgroundClassName(journey.indexColor)
            });
        });

        return {
            title: this.translationService.t("ganttSeriesService.journeys"),
            events: journeyEvents,
            className: "rounded-corners clickable"
        };
    }

    createVideoSeries(videos: IVideoEntry[], min: moment.Moment = null, max: moment.Moment = null): IGanttSeries {
        var videoEvents: IGanttEvent[] = [];

        videos.forEach((video, index) => {
            var colour = this.colourService.getColour(index, false);

            var startUtc = moment(video.VideoStartTime);
            var endUtc = moment(video.VideoEndTime);

            if (min && max && this.isInRange(min, max, startUtc, endUtc)) {
                return;
            }

            if (min && min.isAfter(startUtc)) {
                startUtc = min;
            }

            if (max && max.isBefore(endUtc)) {
                endUtc = max;
            }

            videoEvents.push({
                startUtc: startUtc,
                endUtc: endUtc,
                className: colour.solidColour
            });
        });

        return {
            title: this.translationService.t("ganttSeriesService.videos"),
            events: videoEvents,
            className: "rounded-corners clickable"
        };
    }

    //createActivitySeries() {
    // Stationary
    // Idling
    // Moving

    //var movingEvents: IGanttEvent[] = [];
    //var currentMovingEvent: IGanttEvent = null;

    //var startTime = this.historicalDay.plots[0].UtcMoment;
    //if (this.historicalDay.journeyModel && this.historicalDay.journeyModel.journeys) {
    //    startTime = moment(this.historicalDay.journeyModel.journeys[0].StartUtc);
    //}

    //var endTime = this.historicalDay.plots[this.historicalDay.plots.length - 1].UtcMoment;
    //if (this.historicalDay.journeyModel && this.historicalDay.journeyModel.journeys) {
    //    endTime = moment(this.historicalDay.journeyModel.journeys[this.historicalDay.journeyModel.journeys.length - 1].EndUtc);
    //}

    //var wasTravelling = false;
    //this.historicalDay.plots.forEach(plot => {
    //    if (plot.UtcMoment.isBefore(startTime) || plot.UtcMoment.isAfter(endTime)) {
    //        return;
    //    }

    //    var isTravelling = this.reasonCodeService.isTravelling(plot.Reason);
    //    if (isTravelling != wasTravelling) {
    //        if (currentMovingEvent) {
    //            currentMovingEvent.endUtc = plot.UtcMoment;
    //        }

    //        currentMovingEvent = {
    //            startUtc: plot.UtcMoment,
    //            endUtc: plot.UtcMoment,
    //            className: `rc-${adjustedReason}-background`
    //        };

    //        movingEvents.push(currentMovingEvent);
    //    }

    //    wasTravelling = isTravelling;
    //});

    //this.ganttChartSeries.push({
    //    title: "Activity",
    //    events: movingEvents
    //});
    //}

    createPlotActivitySeries(historicalDay: IHistoricalDay) {
        const ganttChartSeries: IGanttSeries[] = [];
        var movingEvents: IGanttEvent[] = [];
        var currentMovingEvent: IGanttEvent = null;

        var previousReason: ReasonCode = -1;

        var startTime = historicalDay.plots[0].UtcMoment;
        if (historicalDay.journeyModel && historicalDay.journeyModel.journeys) {
            startTime = moment(historicalDay.journeyModel.journeys[0].StartUtc);
        }

        var endTime = historicalDay.plots[historicalDay.plots.length - 1].UtcMoment;
        if (historicalDay.journeyModel && historicalDay.journeyModel.journeys) {
            endTime = moment(historicalDay.journeyModel.journeys[historicalDay.journeyModel.journeys.length - 1].EndUtc);
        }

        //var has = false;

        historicalDay.plots.forEach(plot => {
            //var isTravelling = this.reasonCodeService.isTravelling(plot.Reason);

            //console.log(plot);

            if (plot.UtcMoment.isBefore(startTime) || plot.UtcMoment.isAfter(endTime)) {
                return;
            }

            // This just tidies up lots of "moving" reason codes into a single yellow block for simplicity
            var adjustedReason = this.reasonCodeService.isTravelling(plot.Reason)
                ? ReasonCode.TravelPlot
                : plot.Reason;

            if (adjustedReason != previousReason) {
                //console.log("Plot chjanged", previousReason, plot.Reason);
                if (currentMovingEvent) {
                    currentMovingEvent.endUtc = plot.UtcMoment;
                }

                currentMovingEvent = {
                    startUtc: plot.UtcMoment,
                    endUtc: plot.UtcMoment,
                    className: `rc-${adjustedReason}-background`
                };

                movingEvents.push(currentMovingEvent);
            }

            previousReason = adjustedReason;

            //// Moving events
            //if (!isTravelling && wasTravelling) {
            //    if (currentMovingEvent) {
            //        currentMovingEvent.endUtc = plot.UtcMoment;
            //    }
            //}
            //else if (isTravelling && !currentMovingEvent) {
            //    currentMovingEvent = {
            //        startUtc: plot.UtcMoment,
            //        className: `moving-gantt-event`
            //    };

            //    movingEvents.push(currentMovingEvent);
            //}

            //wasTravelling = isTravelling;
        });

        var lastPlot = historicalDay.plots[historicalDay.plots.length - 1];
        if (lastPlot) {
            if (currentMovingEvent && !currentMovingEvent.endUtc) {
                currentMovingEvent.endUtc = lastPlot.UtcMoment;
            }
        }

        ganttChartSeries.push({
            title: this.translationService.t("ganttSeriesService.activity"),
            events: movingEvents
        });

        return ganttChartSeries;
        // We should filter out any events that are less than < 0.5% width
        //console.log(movingEvents);
    }

    // --------------

    private isInRange(min: moment.Moment, max: moment.Moment, start: moment.Moment, end: moment.Moment) {
        return min.isAfter(end) || max.isBefore(start);
    }
}
